import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectBiologicalSex = ({ selectedBiologicalSex, onChange, disabled }) => {
  const { translate: t } = useDictionaryTranslation();
  const [biologicalSexes, setBiologialSexes] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectBiologicalSex = (item) => {
    const biologicalSex = biologicalSexes.find((bs) => bs.value === item?.value);
    onChange(biologicalSex);
  };

  const getBiologialSexes = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search, isServiceCreation: true };
      const { biologicalSexes: biologicalSexesList } = await InteroperableDataService.getBiologicalSexes(params);
      setBiologialSexes(biologicalSexesList);
    } catch (error) {
      setBiologialSexes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((biologicalSex) => {
    return {
      value: biologicalSex.value,
      label: biologicalSex.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('biologicalSexPlaceholder')}
      isLoading={loading}
      onChange={selectBiologicalSex}
      options={biologicalSexes}
      value={selectedBiologicalSex}
      onSearch={getBiologialSexes}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectBiologicalSex.propTypes = {
  selectedBiologicalSex: PropTypes.shape({
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
